import { API_BASE, apiSlice } from '@/redux/api-slice'
import type { Collection } from './types'

const url = API_BASE + 'collection'

export const collectionsApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ['Collection'],
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getCollections: build.query<Collection[], void>({
        query: () => ({
          url: `${url}`,
          method: 'get',
        }),
        providesTags: ['Collection'],
      }),
      createCollection: build.mutation<Collection, AddCollectionChainRequest>({
        query: (body) => ({
          url: `${url}`,
          method: 'post',
          body,
        }),
        invalidatesTags: ['Collection'],
      }),
      addMediaToCollection: build.mutation({
        query: (mediaToAdd: AddMediaRequest) => ({
          url: `${url}/addMedia`,
          method: 'post',
          body: mediaToAdd,
        }),
      }),
      updateCollectionTitle: build.mutation({
        query: ({ title, collectionCode }: UpdateTitleRequest) => ({
          url: `${url}/${title}/${collectionCode}`,
          method: 'put',
        }),
      }),
    }),
  })

export const {
  useCreateCollectionMutation,
  useAddMediaToCollectionMutation,
  useGetCollectionsQuery,
  useUpdateCollectionTitleMutation,
} = collectionsApi

export default collectionsApi

type CollectionRequest = {
  collectionCode: number
}

type MediaCodes = {
  mediaCodes: number[]
}

type CollectionTitle = {
  title: string
}

type AddCollectionChainRequest = Partial<MediaCodes & CollectionTitle>
type AddMediaRequest = CollectionRequest & MediaCodes
type UpdateTitleRequest = CollectionRequest & CollectionTitle
